<div class="section-row">
  <div class="column first-column">
    <div class="table-header text-ellipsis tooltip-head" *ngIf="profileData.countryOfRisk">
      Top 5 Country/Territory of Risk Weighting
      <div class="tooltip-text">Top 5 Country/Territory of Risk Weighting</div>
    </div>
    <div class="table-header text-ellipsis" *ngIf="profileData.issuerCountry">Top 5 Issuer Country Weighting</div>
    <table class="custom-table-striped">
      <tr>
        <td class="text-ellipsis tooltip-head" *ngIf="profileData.countryOfRisk">
          Country/Territory of Risk
          <div class="tooltip-text"> Country/Territory of Risk </div>
        </td>
        <td *ngIf="profileData.issuerCountry">Issuer Country</td>
        <td style="font-weight: normal">Index Weight</td>
      </tr>
      <tr *ngFor="let country of profileData.countryOfRisk">
        <td class="text-ellipsis tooltip-head">{{country.name}}
          <div class="tooltip-text">{{country.name}}</div></td>
        <td>{{country.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
      <tr *ngFor="let country of profileData.issuerCountry">
        <td class="text-ellipsis tooltip-head">{{country.name}}
          <div class="tooltip-text">{{country.name}}</div></td>
        <td>{{country.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
    </table>
  </div>
  <div class="column second-column">
    <div class="table-header">Top 5 Sector Weighting</div>
    <table class="custom-table-striped">
      <tr>
        <td>Classification</td>
        <td style="font-weight: normal">Index Weight</td>
      </tr>
      <tr *ngFor="let sector of profileData.sectorWeighting">
        <td class="text-ellipsis tooltip-head">{{sector.name}}
          <div class="tooltip-text">{{sector.name}}</div></td>
        <td>{{sector.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
    </table>
  </div>
  <div class="column third-column">
    <div class="table-header">Top 5 Rating Weighting</div>
    <table class="custom-table-striped">
      <tr>
        <td>Rating</td>
        <td style="font-weight: normal">Index Weight</td>
      </tr>
      <tr *ngFor="let rating of profileData.ratingWeighting">
        <td class="text-ellipsis">{{rating.name}}
        <td>{{rating.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
    </table>
  </div>
</div>
<div class="section-row" style="margin-top: 20px" *ngIf="expanded">
  <div class="column first-column">
    <div class="table-header" *ngIf="profileData.tickerWeighting">Top 5 Ticker Weighting</div>
    <div class="table-header" *ngIf="profileData.issuerWeighting">Top 5 Issuer Weighting</div>
    <table class="custom-table-striped">
      <tr>
        <td *ngIf="profileData.tickerWeighting">Ticker</td>
        <td *ngIf="profileData.issuerWeighting">Issuer</td>
        <td style="font-weight: normal">Index Weight</td>
      </tr>
      <tr *ngFor="let ticker of profileData.tickerWeighting">
        <td class="text-ellipsis tooltip-head">{{ticker.name}}
          <div class="tooltip-text">{{ticker.name}}</div></td>
        <td>{{ticker.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
      <tr *ngFor="let issuer of profileData.issuerWeighting">
        <td class="text-ellipsis tooltip-head">{{issuer.name}}
          <div class="tooltip-text">{{issuer.name}}</div></td>
        <td>{{issuer.weight * 100 | number: '1.2-4'}} %</td>
      </tr>
    </table>
  </div>
  <div class="column second-column">
    <div class="table-header" *ngIf="profileData.tickerCount">Top 5 Ticker Count</div>
    <div class="table-header" *ngIf="profileData.issuerCount">Top 5 Issuer Count</div>
    <table class="custom-table-striped">
      <tr>
        <td *ngIf="profileData.tickerCount">Ticker</td>
        <td *ngIf="profileData.issuerCount">Issuer</td>
        <td style="font-weight: normal">Count</td>
      </tr>
      <tr *ngFor="let ticker of profileData.tickerCount">
        <td class="text-ellipsis tooltip-head">{{ticker.name}}
          <div class="tooltip-text">{{ticker.name}}</div></td>
        <td>{{ticker.weight}}</td>
      </tr>
      <tr *ngFor="let issuer of profileData.issuerCount">
        <td class="text-ellipsis tooltip-head">{{issuer.name}}
          <div class="tooltip-text">{{issuer.name}}</div></td>
        <td>{{issuer.weight}}</td>
      </tr>
    </table>
  </div>
  <div class="column third-column">
    <div class="table-header">Top 5 Rating Count</div>
    <table class="custom-table-striped">
      <tr>
        <td>Rating</td>
        <td style="font-weight: normal">Count</td>
      </tr>
      <tr *ngFor="let rating of profileData.ratingCount">
        <td>{{rating.name}}</td>
        <td>{{rating.weight}}</td>
      </tr>
    </table>
  </div>
</div>
